import { supabase } from './supabase'

const METRICS_TABLES = ['daily_metrics', 'weekly_metrics', 'monthly_metrics']

const hasAnyExistingMetrics = async (businessId) => {
  if (!businessId) return false

  const checks = await Promise.all(
    METRICS_TABLES.map(async (table) => {
      const { data, error } = await supabase
        .from(table)
        .select('id')
        .eq('business_id', businessId)
        .limit(1)

      if (error) throw error
      return Array.isArray(data) && data.length > 0
    })
  )

  return checks.some(Boolean)
}

export { hasAnyExistingMetrics }
